// extracted by mini-css-extract-plugin
module.exports = {"container":"hotel_info_container__2Axkm","hotel_name":"hotel_info_hotel_name__cTPs8","timespan":"hotel_info_timespan__2b7ql"};